enum Statuses {
  Active = 'active',
  Inactive = 'inactive',
  Disabled = 'disabled',
  Unconfirmed = 'unconfirmed',
}

export default Statuses;
